import { useToast } from '@app/core/notifications';
import { streamerBoxStreamerBoxDevicesSetCoords } from '@mi-front/api-v2';
import { Coords, Device } from '@mi-front/core';
import { FormModal, ModalController, TextInput, useAsyncViewCtx } from '@mi-front/ui';
import { Place as PlaceIcon } from '@mui/icons-material';
import { Button } from '@mui/material';
import * as yup from 'yup';

import { FormattedMessage, useIntl } from 'react-intl';
interface PropsP {
  readonly device: Device;
  readonly setCoords: (coords: Coords) => Promise<void>;
}

/** Modal UI to set stream-box device coordinates. */
export function DeviceSetCoordsP(p: PropsP) {
  const { $t } = useIntl();
  const { notifySuccess } = useToast();

  return (
    <ModalController
      trigger={(open) => (
        <Button size="small" onClick={open} startIcon={<PlaceIcon />}>
          <FormattedMessage
            id="streamBox.viewScreen.actions.setCoords.button"
            defaultMessage="Establecer coordenadas"
          />
        </Button>
      )}
    >
      {({ show, onHide }) => (
        <FormModal
          show={show}
          onHide={onHide}
          title={
            <>
              <PlaceIcon />{' '}
              <FormattedMessage
                id="streamBox.viewScreen.actions.setCoords.title"
                defaultMessage="Editar coordenadas del dispositivo"
              />
            </>
          }
          initialValues={{
            lat: p.device.coords.lat,
            lng: p.device.coords.lng,
          }}
          onSubmit={async (data) => {
            await p.setCoords(data);
            notifySuccess(
              $t({
                id: 'streamBox.viewScreen.actions.setCoords.done',
                defaultMessage: 'Coordenadas actualizadas',
              }),
            );
          }}
          validationSchema={yup.object().shape({
            device_latitude: yup.number().required(),
            device_longitude: yup.number().required(),
          })}
        >
          {(fp) => (
            <>
              <TextInput
                autoFocus
                value={fp.values.lat}
                onChange={fp.handleChange}
                onBlur={fp.handleBlur}
                required
                name="device_latitude"
                label={
                  <FormattedMessage
                    id="streamBox.viewScreen.actions.setCoords.latitude"
                    defaultMessage="Latitud"
                  />
                }
              />
              <TextInput
                value={fp.values.lng}
                onChange={fp.handleChange}
                onBlur={fp.handleBlur}
                required
                name="device_longitude"
                label={
                  <FormattedMessage
                    id="streamBox.viewScreen.actions.setCoords.longitude"
                    defaultMessage="Longitud"
                  />
                }
              />
            </>
          )}
        </FormModal>
      )}
    </ModalController>
  );
}

/** Sets device coordinates and reloads the parent AsyncView. */
export function DeviceSetCoords(p: { device: Device }) {
  const { reload } = useAsyncViewCtx();

  return (
    <DeviceSetCoordsP
      device={p.device}
      setCoords={async (coords: Coords) => {
        await streamerBoxStreamerBoxDevicesSetCoords(String(p.device.id), {
          latitude: Number(coords.lat),
          longitude: Number(coords.lng),
        });
        reload();
      }}
    />
  );
}
